import * as type from "./questionTypes";
import React from "react";

import washSqCover from '../../images/washSqPark/washSqCover.jpg';
import archBeforeStatues from '../../images/washSqPark/archBeforeStatues.jpg';
import archConspirators from '../../images/washSqPark/archConspirators.jpg';
import exitusActaProbat from '../../images/washSqPark/exitusActaProbat.jpg';
import garibaldiAgeOfStatue from '../../images/washSqPark/garibaldiAge.jpg';
import gwPortrait from '../../images/washSqPark/gwPortrait.jpg';
import hundredYears from '../../images/washSqPark/hundredYears.jpg';
import owtInArch from '../../images/washSqPark/owtInArch.jpg';
import washParkCoordinates from '../../images/washSqPark/washParkCoordinates.jpg';
import woodenArch from '../../images/washSqPark/woodenArch.jpg';
import doorToArch from '../../images/washSqPark/doorToArch.jpg';
import holleyImage from '../../images/washSqPark/holleyImage.jpg';
import steelPlant from '../../images/washSqPark/steelPlant.jpg';
import garibaldiBattle from '../../images/washSqPark/garibaldiBattle.jpg';
import garibaldiImage from '../../images/washSqPark/garibaldiImage.jpg';
import parkingLot from '../../images/washSqPark/parkingLot.jpg';
import chryslerBuilding from '../../images/washSqPark/chryslerBuilding.jpg';
import flatIronBuilding from '../../images/washSqPark/flatIronBuilding.jpg';
import oneWorldTradeBuilding from '../../images/washSqPark/oneWorldTradeBuilding.jpg';
import empireStateBuilding from '../../images/washSqPark/empireStateBuilding.jpg';
import paver from '../../images/washSqPark/paver.jpg';
import nyuFlagImage from '../../images/washSqPark/nyuFlagImage.jpg';
import chessTables from '../../images/washSqPark/chessTables.jpg';
import stanfordWhite from '../../images/washSqPark/stanfordWhite.jpg';
import oldestTreeImage from '../../images/washSqPark/oldestTreeImage.jpg';
import oldestTreeMatrix from '../../images/washSqPark/oldestTreeMatrix.jpg';
import oldestTreeMatrixAnswer from '../../images/washSqPark/oldestTreeMatrixAnswer.jpg';
import metalBird from '../../images/washSqPark/metalBird.jpg';
import mailBoxNest from '../../images/washSqPark/mailBoxNest.jpg';
import nyuMap from '../../images/washSqPark/nyuMap.jpg';
import romanNumerals from '../../images/reflectingPool/questions/Roman-Numerals.png';
import wsOnMemorial from '../../images/washSqPark/wsOnMemorial.jpg'
import westSideOfParkPic from '../../images/washSqPark/westSideOfPark.jpg'
import eastSideOfParkPic from '../../images/washSqPark/eastSideOfPark.jpg'
//Paul bday images
import squatImage from '../../images/paulBirthday/liftImages/squatImage.webp'
import deadliftImage from '../../images/paulBirthday/liftImages/deadliftImage.jpg'
import benchImage from '../../images/paulBirthday/liftImages/benchImage.png'
import pullupsImage from '../../images/paulBirthday/liftImages/pullupsImage.webp'
import PaulUmbrella from '../../images/paulBirthday/PaulUmbrella.png';
import PaulBikeStats from '../../images/paulBirthday/PaulBikeStats.png';
import PaulBiking from '../../images/paulBirthday/PaulBiking.png';
import PaulCake from '../../images/paulBirthday/PaulCake.png';
import PaulHandstand from '../../images/paulBirthday/PaulHandstand.png';
import PaulPushupOnPier from '../../images/paulBirthday/PaulPushupOnPier.png';
import PaulSpock from '../../images/paulBirthday/PaulSpock.png';

import PaulClimbingObstacle from '../../images/paulBirthday/PaulClimbingObstacle.png';
import PaulEatingBroccoli from '../../images/paulBirthday/PaulEatingBroccoli.png';
import PaulFlexing from '../../images/paulBirthday/PaulFlexing.png';
import PaulGlasses from '../../images/paulBirthday/PaulGlasses.png';
import PaulPiggyBack from '../../images/paulBirthday/PaulPiggyBack.png';
import PaulHoldingBroccoli from '../../images/paulBirthday/PaulHoldingBroccoli.png';
import PaulLectins from '../../images/paulBirthday/PaulLectins.JPG';
import PaulRunningInFountain from '../../images/paulBirthday/PaulRunningInFountain.png';
import PaulStandingInField from '../../images/paulBirthday/PaulStandingInField.png';


const washSqArch = {
  name: 'The Arch',
  img: washSqCover,
};

const washSqParkWest = {
  name: 'West side of the park',
  img: westSideOfParkPic,
};

const washSqParkEast = {
  name: 'East side of the park',
  img: eastSideOfParkPic,
};

const paulismsTriviaLocation = {
  name: 'Paul-isms Trivia',
  img: PaulCake,
};

const paulFitnessTriviaLocation = {
  name: 'Paul Fitness Trivia',
  img: PaulCake,
};

const getToWashSqPark = {
  location: washSqArch,
  type: type.newLocation,
  image1: null,
  content1: (<div style={{display: 'flex', flexDirection: 'column', fontStyle: 'italic'}}>
    <div style={{padding: "4px 0"}}>I stand proud and am a sight to behold</div>
    <div style={{padding: "4px 0"}}>My arches reveal a story to be told</div>
    <div style={{padding: "4px 0"}}>I'm made of marble, smooth and bright</div>
    <div style={{padding: "4px 0"}}>A symbol of freedom, a beacon of light</div>
  </div>),
  content2: "Tap 'I'm here' when you are by the described object.",
  //hint: 'Just think about it',
  answer: {
    image1: washSqCover,
    content1: 'You made it to the Washington Arch!',
    content2: 'Get ready for your first question. remember, every question is solvable through observation. '
  }

};



const hollow = {
  displayName: "Filled or Hollow?",
  location: washSqArch,
  type: type.multipleChoice,
  content1: 'The legs of arches like this one can be filled in with material for structural support or hollow to save on construction costs. ',
  boldContent: 'Is the Arch filled in or hollow? ',
  hint: 'If the arch were hollow, people would want a way to get inside. If you see a way in, then it is hollow. If there is no way, it is filled.',
  specialContent: {
    initialCards: ['Filled', 'Hollow',],
  },
  answer: {
    answer: 'Hollow',
    answerInfo: {
      image1: doorToArch,
      image1Caption: "On the Arch’s west side, you can see a door that lets people inside one of the arch legs, indicating that it is hollow.",
    },
    heading: "There's office space inside the arch!",
    content2: "Inside the arch, there is an oval, spiral staircase that takes you to a room above the arch, once used as a NYC Parks office. There's even roof access! These days the arch is rarely accessed in order to preserve the structure.",
  },
};

const freeGreenwich = {
  displayName: "Independent State of Greenwich",
  location: washSqArch,
  type: type.informational,
  content1: 'At the turn of the 20th century, Greenwich village was known as a cultural center for revolutionary new ideas on society, art, and theater.',
  content2: 'One of the most symbolic representations of the Village’s revolutionary spirit was when in 1917, a small, rowdy group of artists and writers, who would become known as “The Arch Conspirators” broke into the arch and occupied the roof for a night, declaring “Greenwich Village a free and independent republic.”',
  image2: archConspirators,
  image2Caption: 'Drawing of the Arch Conspirators by John Sloan',
};

const whichWashington = {
  displayName: "Both are Washington!",
  location: washSqArch,
  type: type.multipleChoice,
  image1: gwPortrait,
  image1Caption: 'Portrait of George Washington',
  content1: 'On the north side of the arch, there are two prominent statues.  ',
  boldContent: 'Which one of these statues is George Washington? ',
  //hint: 'Read the question',
  specialContent: {
    initialCards: ['Left Statue (Hat)', 'Right Statue (No Hat)', 'Both are Washington', 'Neither are Washington'],
  },
  answer: {
    answer: 'Both are Washington',
    image1: null,
    heading: "You're seeing double",
    content1: "Both statues depict George Washington but in different phases of his life! ",
    content2: "On the left is “Washington at War” with Fame and Valor behind him. ",
    content3: "On the right is “Washington at Peace” when he is President. Wisdom and Justice are behind him."
  },
};


const washingtonInauguration = {
  displayName: "Arch purpose",
  location: washSqArch,
  type: type.multipleChoice,
  content1: 'George Washington was so beloved, you can find monuments to him all over the country. In fact the most popular city name in the US is “Washington” with 88 cities and towns named in his honor.',
  content2: 'To solve this next question, examine the north facing side of the arch (statue side).',
  boldContent: 'What part of Washington’s life was the arch built to celebrate?',
  hint: 'Discover the answer to this question by examining the Arch from further away. Specifically, stand close to the nearest street and look back.',
  specialContent: {
    initialCards: ['Washington\'s Birthday', 'The Battle of Yorktown', "Washington's Inauguration", 'Washington\'s Death',],
  },
  answer: {
    answer: 'Washington\'s inauguration',
    answerInfo: {
      image1: hundredYears,
      image1Caption: "At the top of the arch (north side), the inscription says “To commemorate the one hundredth anniversary of the inauguration of George Washington as first president of the United States”",
    },
    heading: "The Arch started as a temporary wooden prop",
    content1: "Ironically, the marble arch you see today was completed in 1895, 106 years after Washington's inauguration -- 6 years late! The reason for this is that plans for the arch were not always set in stone.",
    image3: woodenArch,
    image3Caption: 'Drawing of the original, wooden arch in 1889',
    content3: "In 1889, the actual year for the 100th anniversary, local businessman and Washington fanboy, William Stewart, erected a temporary wooden arch. The public admired the structure so much that Stewart was able to get enough donations to make it a permanent marble fixture."
  },
};

const spotTheDifference = {
  displayName: "Spot the differences",
  location: washSqArch,
  type: type.freeTextQuestion,
  image1: archBeforeStatues,
  image1Caption: "The Arch, circa 1900",
  content1: 'Look at the historical image of the park.',
  boldContent: 'What are some things that have changed? Multiple answers accepted.',
  //hint: "Look at Washington as President's head",

  answer: {
    answer: new RegExp("(fountain|cars|traffic|carriage|car|centered|building|scraper|tree|pave|statue|owt|freedom|tower|world trade|light|lamp)"),
    answerInfo: {
      image1: archBeforeStatues,
      image1Caption: "The Arch, circa 1900",
      content1: (<div>
        <div>There are a few things that have changed since the 1900s image, so we accepted many answers. Here are some of our favorites:</div>
        <ul style={{marginBottom: 0, marginTop: '8px'}}>
          <li>The two statues in the front had not been erected — they were added in 1916 and 1918, more than 20 years after the arch was dedicated.</li>
          <li style={{marginTop: '8px'}}>The fountain was not centered with the arch. In the image, you can see the fountain spouting off center! It was moved ~20ft in 2005 to be aligned with the arch center.</li>
        </ul>
      </div>),
    },
    heading: "Cars once drove straight through the Arch",
    content1: "In the 1900s image, you can see a carriage driving through the arch. That wasn't unusual — traffic drove through the arch until 1958. Thanks to decades of local advocacy, the park went car-free!",
    image2: parkingLot,
    image2Caption: "Washington Square Park before it was pedestrian friendly",
  },
};

const foreignLanguage = {
  displayName: "Foreign Language",
  location: washSqArch,
  type: type.freeTextQuestion,
  content1: 'Look closely at the arch and you’ll see a book with words in Latin.  ',
  boldContent: 'What does it say? ',
  hint: "Look around the head of Washington as President (the right statue)",

  answer: {
    answer: new RegExp("(exitus|acta|probat)"),
    answerInfo: {
      image1: exitusActaProbat,
      image1Caption: "“Exitus acta probat” is written on the book behind the George Washington statue on the right",
    },

    heading: "Washington's motto: the outcome justifies the deed",
    content1: "“Exitus acta probat” is George Washington’s family motto and is Latin for “The outcome justifies the deed.”",
    content2: "This philosophy may have resonated with Washington, who often faced difficult decisions during the Revolutionary War during his Presidency.",
  },
};

const countTheWs = {
  displayName: "Count the Ws",
  location: washSqArch,
  type: type.freeTextQuestion,
  content1: 'To really drive home the point of who this arch celebrates, the arch architect designed lots of “W” carvings into the arch. ',
  boldContent: 'How many Ws can you spot? ',
  hint: "In line with the Eagle, you'll see a row of Ws that go around the entirety of the Arch",

  answer: {
    answer: new RegExp("(^14$|^fourteen$|^19$|^nineteen$)"),
    answerInfo: {
      image1: wsOnMemorial,
      image1Caption: "",
      content1: (<div>
        <div>There are 14 Ws that go around the top of the arch:</div>
        <ul style={{marginBottom: 0, marginTop: '4px'}}>
          <li>North side: 6</li>
          <li>East side: 1</li>
          <li>South side: 6</li>
          <li>West side: 1</li>
        </ul>
        <div style={{marginBottom: 0, marginTop: '8px'}}>If you ask us, this misses an opportunity for a symbolic 13, to represent the 13 original colonies. </div>
        <div style={{marginBottom: 0, marginTop: '16px'}}>If you were really thinking outside of the box, you may have noticed that there are five additional Ws in the quotes and other inscriptions on the memorial, so we also accepted 19.</div>

      </div>),
    },

    image1: null,

    //content1: "There are fourteen Ws! There are six on the North, one on the East, one on the West, and six on the South side. If you asked us, this misses an opportunity for thirteen, to represent the thirteen original colonies. If you were really thinking outside of the box, you may have noticed that there are five Ws in the quotes and other inscriptions on the memorial, so we also accepted 19. \n",
    image3: stanfordWhite,
    image3Caption: "Arch Architect: Stanford White",
    heading: "The architect borrowed from Rome — and then added Ws",
    content3: "The Ws and everything else about the memorial were the artistic decision by famous architect Stanford White. White had several other arches to draw inspiration from at the time -- the Romans famously built arches in many cities to commemorate victory and the Parisian Arc de Triomphe was built only 53 years before White started his work. "
  },
};

const startWestSide = {
  displayName: "Start West Side of Park",
  location: washSqParkWest,
  type: type.informational,
  image1: westSideOfParkPic,
  content1: 'The next set of questions take place in the West side of the park',
};

const famousBuilding = {
  displayName: "Famous Building",
  location: washSqParkWest,
  type: type.multipleChoice,
  content1: "The arch is on the north side of the park.",
  boldContent: 'What famous building can you see to the south? ',
  //hint: 'Read the question',
  specialContent: {
    initialCards: ['Empire State Building', 'Chrysler Building', 'One World Trade Center', 'Flatiron Building'],
    initialImages: [empireStateBuilding, chryslerBuilding, oneWorldTradeBuilding, flatIronBuilding]
  },
  answer: {
    answer: 'One World Trade Center',
    answerInfo: {
      image1: owtInArch,
      image1Caption: "One World Trade Center, pictured through the arch",
      content1: "You may have to move a little to the West, but you can see the One World Trade Center to the South! All the other buildings that were options are to the North.",
    },
    heading: "One World Trade peeks through the Arch to the south",
    content1: "The skyscraper was initially called the Freedom Tower before being officially renamed. One World Trade stands at a symbolic 1776 feet tall, which is also the year the Declaration of Independence was signed.",

  },
};

const holley = {
  displayName: "Mustache Man",
  location: washSqParkWest,
  type: type.freeTextQuestion,
  content1: 'Walk through the West side of the park and you’ll find a mustachioed man of steel but who has a bust of bronze. ',
  boldContent: 'What is his name? ',
  hint: "Start at the fountain and walk West",
  answer: {
    answer: new RegExp("(holley|holly|holy|alexander)"),
    answerInfo: {
      image1: holleyImage,
      image1Caption: "Alexander Holley's bronze bust and memorial, due west of the fountain",
      caption1: "",
    },

    heading: "Skyscrapers wouldn't exist without the the mustache man's inventions",
    content1: "Most people do not recognize the Alexander Holley name. The same was true when he died in 1882 and his memorial was erected - newspapers complained that the city was wasting precious park space for statues that people do not know.",
    image2: steelPlant,
    image2Caption: "Illustrations of a steel plant employing the bessemer process",
    content2: "However, Holley had a tremendous impact on American society — his innovations in steel production using the Bessemer process significantly lowered costs so that steel could be mass produced. This, in turn, led to the development of new technologies which relied heavily on steel, such as railroads, skyscrapers, and bridges. Holley's legacy in engineering and manufacturing continues to be felt to this day!",
  },
};

const purpleFlag = {
  displayName: "Purple Flag",
  location: washSqParkWest,
  type: type.freeTextQuestion,
  content1: 'From within the park, you can spy several purple and white flags on surrounding buildings.  ',
  boldContent: 'What does it say on the flag? ',
  hint: "This flag is in several places. Look at the rooftops towards the East, or walk along the park perimeter and look for flags on top of building entrances",

  answer: {
    answer: new RegExp("(nyu|university)"),
    answerInfo: {
      image1: nyuFlagImage,
      image1Caption: "Many surrounding buildings have flags that say NYU.",
    },

    // content1: "Why is purple the NYU color? The origin is not known but NYU suggests two theories:",
    // content2: (<ol>
    //   <li>Violets used to grow abundantly in Washington Square park and around the original University buildings.</li>
    //   <li>The violet was the flower of Athens in Ancient Greece -- a city famous for education and knowledge and thus worthy of mirroring.</li>
    // </ol>),
    // content2: "Theory 1: Violets used to grow abundantly in Washington Square park and around the original University buildings.",
    // content3: "Theory 2: The violet was the flower of Athens in Ancient Greece -- a city famous for education and knowledge and thus worthy of mirroring.",
    image1: nyuMap,
    image1Caption: "Buildings shaded purple are NYU properties",
    heading: "Washington Square is basically NYU's quad",
    content1: "Almost all the buildings around Washington Square park are NYU buildings, which is why the park is often full of students."
  },
};

const oldestTree = {
  displayName: "Oldest Tree",
  location: washSqParkWest,
  image1: oldestTreeMatrix,
  type: type.multipleChoice,
  content1: 'The oldest tree in Manhattan is in Washington Square Park! However it is not labelled and you will need to walk around and use your best judgement to discover it.',
  boldContent: 'Which plot contains the oldest tree?',
  hint: 'You can sometimes estimate the age of a tree by how wide its trunk is. Look for the tree with the widest base.',
  specialContent: {
    initialCards: ['1', '2', '3', '4', '5', '6'],
  },
  answer: {
    answer: '6',
    answerInfo: {
      image1: oldestTreeMatrixAnswer,
      image1Caption: "The tree is located in the NW corner of the park (plot 6)",
      image2: oldestTreeImage,
      image2Caption: "You can tell this tree is the oldest compared to the others because it has the thickest trunk, which is a proxy for tree age.",
      caption1: "",
    },
    heading: "Manhattan's oldest tree is known as Hangman's Elm",
    content1: "Experts estimate that this English Elm has been alive since at least 1689. That makes the tree over 330 years old!",
    content2: "This tree is even older than George Washington and has survived some major historical NYC events, such as the revolutionary war, the war of 1812, the civil war draft riots, 9/11, and Hurricane Sandy. The tree has a dark history though as it’s known as “Hangman’s Elm.” Legend has it that criminals used to be executed here by hanging in the 1700s."
  },
};

const chessPlaza = {
  displayName: "Chess Plaza",
  location: washSqParkWest,
  type: type.freeTextQuestion,
  content1: 'Wander to another corner of the park and you’ll find the Kings and the Queens of Washington Square. However the number of Kings that can officially be here at one time is capped.',
  boldContent: 'What is the most number of Kings that can officially be in this special place at any given time?',
  hint: "Look for a game that has kings and queens; consider how many tables there are and how many kings can be on the table at each time",

  answer: {
    answer: new RegExp("(36|thirty six)"),
    answerInfo: {
      image1: chessTables,
      image1Caption: "At “Chess Plaza,” there are 18 official tables. Each board can have two kings; one white and one black, thus there can be a max of 36 kings (18 x 2)!",
    },
    heading: "World champions have studied chess in this plaza",
    content1: "Some of the chess hustlers here play chess for a living and will charge you if you want to play them. Some may be willing to bet on the game, where you only pay if you lose. Others will offer to give you a chess lesson for compensation.",
    content2: "Washington Square park is famous for its chess scene. World Champions and Grand Masters, like Bobby Fisher, used to play here. For the uninitiated, Bobby Fisher was a child chess prodigy, winning the US championship at the age of 14. ",
  },
};

const pottersField = {
  displayName: "Potter's Field",
  location: washSqParkWest,
  type: type.freeTextQuestion,
  content1: 'Before it was Washington Square Park, this area was known by a different name. But don\'t look up to find it—look down! On one of the park paths near the Sullivan Street etnrance and by a cluster of holly trees, you\'ll find a paver that holds the secret to the park\'s ghoulish past.',
  boldContent: 'What was this area known as between 1797 and 1825?',
  hint: "The paver is one of the large stones that borders the edge of the walking path. Start at Sullivan St and walk the path that takes you to the park buildings, examining the path's edge on the right",

  answer: {
    answer: new RegExp("(potter)"),
    answerInfo: {
      image1: paver,
      image1Caption: "The paver detailing the area's history as a Potter's field",
      caption1: "",
    },
    heading: "Up to 20,000 people are buried beneath this park",
    content1: "Back in the day, New York City was just a a few streets on the tip of Manhattan and the area that’s today Washington Square was considered rural. The city purchased land from a farmer to use as a Potter’s field -  a burial ground for the unfortunate who had no one to give them a proper burial, such as criminals, the poor, and victims of epidemics.",
    content2: "The city sheriff even built a public gallows near the current location of the Square's fountain, optimizing the distance between execution and burial. Yikes! Accelerated by several Yellow Fever epidemics, the Potter’s field eventually reached max capacity. As many as 20,000 people are buried here, giving rise to legends of ghosts haunting the park.",
    content3: "In 1827, the Potter’s field was converted into a military parade ground with time bringing about a rebranding to its current name, \"Washington Square.\" Who knew that beneath the idyllic scenery of this park lies such a dark and intriguing history?",
  },
};

const lampPost = {
  displayName: "Metal Bird",
  location: washSqParkWest,
  type: type.freeTextQuestion,
  content1: (<div style={{display: 'flex', flexDirection: 'column', fontStyle: 'italic'}}>
    <div style={{padding: "4px 0"}}>I have wings but I cannot fly </div>
    <div style={{padding: "4px 0"}}>I am not alone and have a flock nearby </div>
    <div style={{padding: "4px 0"}}>I have a brilliant perch, perfect to spy </div>
  </div>),
  boldContent: 'What is it I sit on top of, oh so high?',
  hint: "Consider the definition of brilliant: very bright and radiant (Oxford Dict)",

  answer: {
    answer: new RegExp("(light|lamp|post)"),
    answerInfo: {
      image1: metalBird,
      image1Caption: "Most of the lamp posts within the park have metal bird sculptures on top of them",
      caption1: "",
    },
    //heading: "The Birds Aren't Real movement would like a word",
    content1: "The #BirdsArentReal movement probably has something to say about that",
  },
};

const startEastSide = {
  displayName: "Start East Side of Park",
  location: washSqParkEast,
  type: type.informational,
  image1: eastSideOfParkPic,
  content1: 'The next set of questions take place in the East side of the park',
};

const findGaribaldi = {
  displayName: "Find Garibaldi",
  location: washSqParkEast,
  type: type.freeTextQuestion,
  content1: 'Wander to the East side of the park and you’ll find a statue of a bearded warrior, pulling his sword out of his scabbard, as if getting ready to charge into battle at any moment.',
  boldContent: 'What is his name?',
  hint: "Start at the fountain and take thirty paces to the East",

  answer: {
    answer: new RegExp("(garibaldi)"),
    answerInfo: {
      image1: garibaldiImage,
      image1Caption: "",
      caption1: "",
    },

    heading: "Italian war hero is important to Italian New Yorkers",
    content1: "Garibaldi was a leading Italian figure and military commander for Italian unification. You may be wondering “why is there a statue for an Italian that was not involved in American history?”",
    content2: "The answer is that there were lots of Italian immigrants living in New York that were fans of Garibaldi’s revolutionary deeds in Europe and donations poured in for his memorial after his death. Garibaldi was particularly popular with Italian-Americans in New York as he had lived on Staten Island for a year during a period of exile from Italy and got to know many in the community.",
    image3: garibaldiBattle,
    image3Caption: 'Garibaldi leading his “Red Shirts” at the Battle of Calatafimi',
    content3: "Garibaldi’s military acumen was so renowned that during the American Civil War, Lincoln offered him a major general's commission (Garibaldi declined)."
  },
};

const garibaldiAge = {
  displayName: "Garibaldi Age",
  location: washSqParkEast,
  type: type.multipleChoice,
  image1: romanNumerals,
  content1: 'Keeping in mind that the Arch was completed in 1895,',
  boldContent: 'who’s monument was installed first?',
  hint: "Look at the back of Garibaldi's statue and you will see the year it was erected in Roman numerals",
  specialContent: {
    initialCards: ['Garibaldi', 'Washington',],
  },
  answer: {
    answer: 'Garibaldi',
    answerInfo: {
      image1: garibaldiAgeOfStatue,
      image1Caption: 'The back of the Garibaldi pedestal says MDCCCLXXXVIII, which is equal to 1888',
      content1: "Garibaldi’s statue was first! The inscription on the back says it was installed in 1888, one year before the 100 year anniversary of Washington’s inauguration (1889), when the first wooden Washington arch was installed.",
    },
    heading: "Garibaldi beat Washington to the park by a year",
    content1: " ",
  },
};

const mailBox = {
  displayName: "Mailbox",
  location: washSqParkEast,
  type: type.freeTextQuestion,
  content1: "There's an unusual animal home up in the trees that's made by human hands. It was not originally built to be an animal shelter but was manufactured for another purpose.",
  boldContent: 'What was the animal home originally?',
  hint: "Walk around the east side of the park. Looks about 15 feet up the tree trunk. Ignore any traditional bird houses you may see",

  answer: {
    answer: new RegExp("(mail)"),
    answerInfo: {
      image1: mailBoxNest,
      content1: "There are several \"US Mail\" mailboxes attached to trees in the park. These were setup by the park service.",
    },
    //heading: "What's more environmentally conscious than re-using an old item to help wildlife?",
    content1: "What's more environmentally conscious than re-using an old item to help wildlife?",


  },
};

// File: paulTriviaQuestions.js

const paulismsTrivia = {
  displayName: "Paul-isms Trivia",
  location: paulismsTriviaLocation,
  type: type.informational,
  image1: PaulGlasses,
  content1: 'We are taking a break from the typical course to ask you some Paul trivia!',
};

const paulFridge = {
  displayName: "Paul's Fridge",
  location: paulismsTriviaLocation, // Set your location
  type: type.freeTextQuestion,
  image1: PaulHoldingBroccoli,
  content1: "Paul's fridge is a study in minimalism and unconventional dieting.",
  boldContent: "Name something you’re guaranteed to find in Paul's fridge",
  hint: "One of them is a fish, the other is particular kind of water",
  answer: {
    answer: new RegExp("(salmon|perrier|avo|energy)"),
    image1: PaulLectins,
    content1: "Perrier for hydration, raw salmon for...reasons. What you won’t find: LECTINS. Paul has declared war on them.",
  },
};

const paulRestaurants = {
  displayName: "Paul's Loyalty",
  location: paulismsTriviaLocation,
  type: type.freeTextQuestion,
  image1: PaulEatingBroccoli,
  content1: "One of Paul's great traits is loyalty. It runs deep — not just for friendships but extending even for food spots. ",
  boldContent: 'Name one restaurant Paul is a regular at:',
  hint: "One of these has great salads",
  answer: {
    answer: new RegExp("(sweet|chipotle|somtum|sumtum|takahatchi|banter|fei)"),

    content1: "Paul's holy pilgrimage route of food includes Sweetgreen, Chipotle, Takahatchi, Somtum Der, and Banter.",
    //content2: "Lettuce pray for Paul's Sweetgreen addiction. 🌱",
  },
};

const paulSweetgreenOrder = {
  displayName: "Paul's Sweetgreen Order",
  location: paulismsTriviaLocation,
  type: type.freeTextQuestion,
  content1: "Paul basically keeps Sweetgreen in business and may be solely responsible for half of their stock's market cap. ",
  boldContent: "What’s the average $ amount of Paul’s Sweetgreen order? Answers within $2 count",
  hint: "It’s... a lot. Special boys need special bowls that include triple protein.",
  answer: {
    answer: new RegExp("(20|21|22|23|24)"), // Adjust range if needed
    content1: "Is a triple protein bowl high maintenance or high standards? You decide.",
    content2: "Lettuce keep Paul’s wallet in our thoughts and prayers.",
  },
};

const paulWanderlust = {
  displayName: "Paul's Wanderlust",
  location: paulismsTriviaLocation,
  type: type.freeTextQuestion,
  image1: PaulRunningInFountain,
  content1: "One of Paul’s hot takes is that \"wanderlust\" in a dating bio is a yellow flag... but the man has some stamps on his passport.",
  boldContent: 'Name a country Paul has traveled to:',
  answer: {
    answer: new RegExp("(portugal|france|columbia|colombia|germany|norway|sweden|britain|england)"),
    image1: PaulUmbrella,
    content1: "Call him Mr. Worldwide; Paul has been to Portugal (Azores), France, Germany, Norway, Sweden, Britain, and Columbia.",
  },
};

const paulFitnessTrivia = {
  displayName: "Paul Fitness Trivia",
  location: paulFitnessTriviaLocation,
  type: type.informational,
  image1: PaulPiggyBack,
  content1: 'Paul Trivia round two! These are all about Paul\'s exercise habits',
};

const paulMarathon = {
  displayName: "Paul's Marathon",
  location: paulFitnessTriviaLocation,
  type: type.freeTextQuestion,
  image1: PaulStandingInField,
  content1: "Paul claimed 'long distance running is easy!' So naturally, to prove his point, he ran a full marathon without training.",
  boldContent: "What was Paul’s marathon time in total minutes? Answers within 15 min count",
  answer: {
    answer: new RegExp("^(22[0-9]|23[0-9]|24[0-9]|250)$"), //answer is 235
    content1: "Paul ran an impressive 3:55 (8:58 avg mile pace) to beat his friend that he challenged. He also temporarily lost the ability to walk. 🦵 RIP",
  },
};

const paulCitibike = {
  displayName: "Paul's Citibike Obsession",
  location: paulFitnessTriviaLocation,
  type: type.freeTextQuestion,
  image1: PaulBiking,
  content1: "Paul hasn’t taken an Uber in THREE years. Instead, you'll find him on a Citibike — even to LaGuardia Airport (no, seriously).",
  content2: "There are 2,799 Citibike docks total.",
  boldContent: "What % of Citibike docks has Paul visited? Answers within 5% count.",
  answer: {
    answer: new RegExp("(12|13|14|15|16|17|18|19|20|21|22|23)"), // Adjust range if needed
    content1: "Paul has been to 496 docks, representing 18% of all docks",
    image2: PaulBikeStats,
    image2Caption: "Paul's stats as of April 30th, 2025",
    content2: "Paul's is also a Citibike 'angel' and has made close to $1,000 by helping rebalance the system. ",
  },
};

const paulStrength = {
  displayName: "Paul's Strength Stats",
  location: paulFitnessTriviaLocation,
  type: type.mixAndMatch,
  image1: PaulFlexing,
  content1: "Paul takes his fitness very seriously; he may spend more time at the gym than at home. Can you guess his max lifts?",
  boldContent: "Match the lift to Paul's max weight:",
  specialContent: {
    initialCards: ['22', '365', '300', '245'],
    initialImages: [squatImage, deadliftImage, benchImage, pullupsImage], // Replace with actual images
  },
  answer: {
    answer: ['300', '365', '245', '22'],
    image1: null,
    content1: "Clearly something about Paul's routine is working. Maybe we should all stop eating lectins and start cross-fitting.",
    //content2: "Paul can thank Brian Lee for pushing him to reach his peak performance"
  },
};

const paulHomeGym = {
  displayName: "Paul's Home Gym",
  location: paulFitnessTriviaLocation,
  type: type.freeTextQuestion,
  image1: PaulClimbingObstacle,
  content1: "Paying for three gym memberships is not enough fitness for Paul; Paul also has a fitness machine in his bedroom so he can start working out immediately upon waking up (definitely not cause he has a small NYC apartment).",
  boldContent: "What fitness machine does Paul have at home?",
  hint: "This is a popular crossfit machine, which involves a pulling motion",
  answer: {
    answer: new RegExp("(row|erg)"),
    content1: "It’s a Rower (ERG)! Who needs furniture when you have fitness?",
  },
};

export const paulTriviaContent = {
  //
  paulismsTrivia,
  paulFridge,
  paulRestaurants,
  paulSweetgreenOrder,
  paulWanderlust,
  //paul trivia part 2
  paulFitnessTrivia,
  paulMarathon,
  paulCitibike,
  paulStrength,
  paulHomeGym,
}

export const paulBdayCourseContent = {
  //
  getToWashSqPark,
  hollow,
  freeGreenwich,
  whichWashington,
  washingtonInauguration,
  foreignLanguage,
  spotTheDifference,
  countTheWs,
  //
  paulismsTrivia,
  paulFridge,
  paulRestaurants,
  paulSweetgreenOrder,
  paulWanderlust,
  //West side of park,
  startWestSide,
  famousBuilding,
  holley,
  purpleFlag,
  oldestTree,
  chessPlaza,
  pottersField,
  lampPost,
  //paul trivia part 2
  paulFitnessTrivia,
  paulMarathon,
  paulCitibike,
  paulStrength,
  paulHomeGym,
  //East side of park
  startEastSide,
  findGaribaldi,
  garibaldiAge,
  mailBox
};

export const washSqParkCourseContent = {
  getToWashSqPark,
  hollow,
  freeGreenwich,
  whichWashington,
  washingtonInauguration,
  foreignLanguage,
  spotTheDifference,
  countTheWs,
  //West side of park,
  startWestSide,
  famousBuilding,
  holley,
  purpleFlag,
  oldestTree,
  chessPlaza,
  pottersField,
  lampPost,
  //East side of park
  startEastSide,
  findGaribaldi,
  garibaldiAge,
  mailBox
};